'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Fees = require('./Fees');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Fees).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Fees/index.js
// module id = 1184
// module chunks = 1